import ReminderAPI from '@/app/apis/main/reminder/reminder-api.js';

export default {
    /**
	 * @return {*} reminder list
	 */
	async getReminderLists(reminderDetails) {
        return ReminderAPI.getReminderLists(reminderDetails);
	},
	
	/**
	 * @param {*} reminderDetails
	 */
	async saveReminder(reminderDetails) {
        return ReminderAPI.saveReminder(reminderDetails);
	},

	/**
	 * @param reminderId
	 * @param {*} reminderDetails
	 */
	async updateReminder(reminderId, reminderDetails) {
        return ReminderAPI.updateReminder(reminderId, reminderDetails);
	},

	/**
	 * @param reminderId
	 * @param {*} reminderDetails
	 */
	async updateReminderStatus(reminderId, reminderDetails) {
        return ReminderAPI.updateReminderStatus(reminderId, reminderDetails);
	}
}